import { api } from './util';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/i18n/datepicker-cs';
import 'jquery-ui/ui/widgets/tooltip';
import tippy from 'tippy.js';

/**
 * Plugin for datepicker.
 * https://github.com/t1m0n/air-datepicker
 */
(function ($) {
	$.fn.jsDatepicker = function () {
		this.each(function () {
			$(this).attr('type', 'text');
			$(this).prop('readonly', true);
			$(this).datepicker({
				language: 'cs',
				dateFormat: 'yy-mm-dd',
			});

			const milliseconds = Date.parse($(this).val());

			if (milliseconds) {
				$(this).datepicker('setDate', new Date(milliseconds));
			}
		});
	};
})(jQuery);

/**
 * Plugin for two datepickers to select date range.
 */
(function ($) {
	function getDate(element) {
		try {
			return $.datepicker.parseDate('yy-mm-dd', $(element).val());
		} catch (error) {
			console.error('could not parse date', error);
			return null;
		}
	}

	$.fn.rangeDatepicker = function (inputUntil) {
		this.jsDatepicker();
		inputUntil.jsDatepicker();

		const datepickerSince = this;
		const datepickerUntil = inputUntil;

		if (!datepickerSince || !datepickerUntil) {
			return;
		}

		datepickerUntil.datepicker('option', 'minDate', this.val());
		datepickerSince.datepicker('option', 'maxDate', inputUntil.val());

		datepickerSince.on('change', (e) => {
			datepickerUntil.datepicker('option', 'minDate', getDate(e.target));
		});
		datepickerUntil.on('change', (e) => {
			datepickerSince.datepicker('option', 'maxDate', getDate(e.target));
		});
	};
})(jQuery);

/**
 * Plugin to focus input and move cursor to the text end.
 * https://stackoverflow.com/questions/4609405
 */
(function ($) {
	$.fn.focusTextToEnd = function () {
		this.focus();
		var value = this.val();
		this.val('').val(value);

		return this;
	};
})(jQuery);

/**
 * Form validation plugin with submit button disable feature.
 */
(function ($) {
	$.fn.validateForm = function () {
		var validate = function () {
			var form = $(this).closest('form');
			var requiredValues = form.find('[required]').map(convertValueToBool).get();
			form.find('[type=submit]').prop('disabled', !requiredValues.reduce(and, true));
		};

		var convertValueToBool = function () {
			return !!$(this).val().trim();
		};

		var and = function (firstValue, secondValue) {
			return firstValue && secondValue;
		};

		this.each(function () {
			$(this).attr('novalidate', true);
			$(this).find('input[type=email]').attr('type', 'text');
			$(this).find('input:first').focusTextToEnd();
			$(this).find('[required]').on('input', validate).trigger('input');
		});

		return this;
	};
})(jQuery);

/**
 * Plugin to create AJAX request with a button.
 */
(function ($) {
	$.fn.apiButton = function (createApiRequest) {
		this.click(function () {
			var button = $(this);
			button.prop('disabled', true);
			createApiRequest(this).always(function () {
				button.prop('disabled', false);
			});

			return false;
		});

		return this;
	};
})(jQuery);

/**
 * Plugin to load more items by AJAX.
 */
(function ($) {
	$.fn.loadMore = function (url, success) {
		var page = 1;

		this.apiButton(function () {
			return api.get(url + (url.indexOf('?') < 0 ? '?' : '&') + 'page=' + (page + 1)).done(function (response) {
				page++;
				success(response);
			});
		});

		return this;
	};
})(jQuery);

/**
 * Plugin to load more items by AJAX.
 */
(function ($) {
	$.fn.loadMoreWithSort = function (url, success, datagrid) {
		this.apiButton(function () {
			return api
				.get(
					url +
						(url.indexOf('?') < 0 ? '?' : '&') +
						'page=' +
						(datagrid.page + 1) +
						'&order=' +
						datagrid.order +
						'&sort-direction=' +
						datagrid.sortDirection
				)
				.done(function (response) {
					datagrid.page++;
					success(response);
				});
		});

		return this;
	};
})(jQuery);

/**
 * Plugin to change sorting order by AJAX.
 */
(function ($) {
	$.fn.sortButton = function (url, success, datagrid) {
		var orderInput = $('input[name=order]');
		datagrid.order = orderInput.val();
		var buttons = $(this);
		var removeClasses = function () {
			buttons.each(function (i, button) {
				$(button).removeClass('asc');
				$(button).removeClass('desc');
			});
		};

		$(this).each(function (i, button) {
			var buttonOrder = $(button).data('medical-device-sort');

			var currentOrder = orderInput.val();

			if (currentOrder === buttonOrder + 'Asc') {
				removeClasses();
				$(button).addClass('asc');
			} else if (currentOrder === buttonOrder + 'Desc') {
				removeClasses();
				$(button).addClass('desc');
			}

			$(this).apiButton(function () {
				var nextOrder;
				if (
					datagrid.order === datagrid.defaultOrder ||
					(datagrid.order !== buttonOrder + 'Asc' && datagrid.order !== buttonOrder + 'Desc')
				) {
					nextOrder = buttonOrder + 'Asc';
					removeClasses();
					$(button).addClass('asc');
				} else if (datagrid.order === buttonOrder + 'Asc') {
					nextOrder = buttonOrder + 'Desc';
					removeClasses();
					$(button).addClass('desc');
				} else {
					nextOrder = datagrid.defaultOrder;
					removeClasses();
				}

				datagrid.page = 1;
				datagrid.order = nextOrder;
				orderInput.val(nextOrder);

				return api
					.get(url + (url.indexOf('?') < 0 ? '?' : '&') + 'page=1&order=' + datagrid.order)
					.done(function (response) {
						success(response);
					});
			});
		});

		return this;
	};
})(jQuery);

/**
 * Plugin for popovers.
 */
(function ($) {
	var hidePopover = function (selector) {
		$(selector).hide();
	};

	var initPopoverHide = function (selector) {
		$(document).on('click', function (event) {
			if ($(event.target).closest('button').length > 0 || $(event.target).closest(selector).length === 0) {
				hidePopover(selector);
			}
		});
	};

	$.fn.popover = function (selector) {
		this.click(function () {
			var popover = $(this).parent().find(selector);
			var isOpen = popover.is(':visible');
			hidePopover(selector);

			if (!isOpen) {
				popover.show();
			}

			return false;
		});
		initPopoverHide(selector);

		return this;
	};
})(jQuery);

/**
 * Table with clickable rows.
 */
(function ($) {
	var getSelectionText = function () {
		if (window.getSelection) {
			return window.getSelection().toString();
		}

		if (document.selection && document.selection.type !== 'Control') {
			return document.selection.createRange().text;
		}

		return '';
	};

	$.fn.clickableRow = function (detailClass) {
		this.each(function () {
			if ($(this).find('.' + detailClass).length > 0) {
				$(this).addClass('table-clickable-row');
				$(this).css('cursor', 'pointer');
			}
		});
		this.mouseup(function (event) {
			if (event.button !== 0) {
				return;
			}

			var detailButton = $(this).find('.' + detailClass);

			// Do nothing when user clicks directly on the button.
			if (detailButton.length === 0 || $(event.target).hasClass(detailClass)) {
				return;
			}

			// Do nothing when user clicks directly on the plus button.
			if ($(event.target).parents('.item-tag').length > 0) {
				return;
			}

			// Do nothing when there is selected text in the element - user probably wants to copy
			// the text from the element. We consider a text of length < 3 as a randomly selected
			// text probably by error.
			var selectionText = getSelectionText().replace(/[\s]+/g, ' ');
			var elementText = $(this).text().replace(/[\s]+/g, ' ');

			if (selectionText.length >= 3 && elementText.indexOf(selectionText) > -1) {
				return;
			}

			// Follow the link.
			if (detailButton.attr('href')) {
				if (event.ctrlKey) {
					window.open(detailButton.attr('href'));
				} else {
					location.href = detailButton.attr('href');
				}
			} else {
				detailButton.click();
			}
		});

		return this;
	};
})(jQuery);

/**
 * Open ProcedureDocument and scroll to it (show its files)
 */
(function ($) {
	$.fn.openProcedureDocument = function (referenceNumber) {
		const id = referenceNumber.replace(/\//g, '--');
		const td = $('#' + id);

		if (td.length === 0) {
			return;
		}

		const actClass = 'table-item-act';
		const detailsSelector = '.table-item-showmore';

		const table = td.closest('table');
		const row = td.closest('tr');

		table.find('tr').removeClass(actClass);
		table.find(detailsSelector).hide();

		row.addClass(actClass);
		row.next(detailsSelector).show();

		document.getElementById(id).scrollIntoView({
			behavior: 'smooth',
		});
	};

	$('body').on('click', '.show-document', (event) => {
		window.location.hash = $(event.currentTarget).prop('hash');
		$('.detail-tabs a').tabs('.tab-content', 'item-act');

		return false;
	});
})(jQuery);

/**
 * Tabbed content plugin.
 */
(function ($) {
	$.fn.tabs = function (contents, activeClass) {
		const tabHeaders = this;
		this.click(function () {
			if ($(this).hasClass('disabled')) {
				return false;
			}

			tabHeaders.removeClass(activeClass);
			$(this).addClass(activeClass);
			$(contents).hide();
			$(contents)
				.filter('[data-tab=' + $(this).data('tab') + ']')
				.show();
		});

		// If we have hash in URL we want to change default tab
		if (window.location.hash) {
			const hash = window.location.hash.substring(1);
			const parts = hash.split('+');
			const section = parts[0];
			const newActiveHeader = tabHeaders.filter('[data-tab=' + section + ']');
			const newActiveTab = $(contents).filter('[data-tab=' + section + ']');

			if (newActiveTab.length > 0 && newActiveHeader.length > 0) {
				tabHeaders.removeClass(activeClass);
				newActiveHeader.addClass(activeClass);
				$(contents).hide();
				newActiveTab.show().after(() => {
					if (parts.length > 1) {
						$('body').openProcedureDocument(parts[1]);
					}
				});
			}
		}

		return this;
	};
})(jQuery);

/**
 * Tooltip plugin (title attribute)
 */
(function ($) {
	tippy('.tooltip');
})(jQuery);

/**
 * Plugin to toggle table detail rows.
 */
(function ($) {
	$.fn.toggleTableDetails = function (detailsSelector, activeClass) {
		this.click(function () {
			var table = $(this).closest('table');
			var row = $(this).closest('tr');
			var isOpen = row.hasClass(activeClass);

			table.find('tr').removeClass(activeClass);
			table.find(detailsSelector).hide();

			if (!isOpen) {
				row.addClass(activeClass);
				row.next(detailsSelector).show();
			}
		});

		return this;
	};
})(jQuery);
